import { createContext } from 'react';

export type TicketCommentCreationCtx = {
  showTicketCommentCreateErrorAlert: boolean;
  showTicketCommentCreateSuccessAlert: boolean;
  showTicketTips: boolean;
  ticketCommentCreateError: string;
};

const TicketCommentContext = createContext<TicketCommentCreationCtx>({
  showTicketCommentCreateErrorAlert: false,
  showTicketCommentCreateSuccessAlert: false,
  showTicketTips: false,
  ticketCommentCreateError: '',
});

export default TicketCommentContext;
